var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-print",
    "data-name": "Icon awesome-print",
    d: "M8.75,3.75V1.509a.625.625,0,0,0-.183-.442L7.683.183A.625.625,0,0,0,7.241,0H1.875A.625.625,0,0,0,1.25.625V3.75A1.25,1.25,0,0,0,0,5V7.188A.312.312,0,0,0,.313,7.5H1.25V9.375A.625.625,0,0,0,1.875,10h6.25a.625.625,0,0,0,.625-.625V7.5h.938A.312.312,0,0,0,10,7.188V5A1.25,1.25,0,0,0,8.75,3.75Zm-1.25,5h-5V6.875h5Zm0-4.375h-5V1.25H6.25v.938a.312.312,0,0,0,.313.313H7.5Zm.938,1.406a.469.469,0,1,1,.469-.469A.469.469,0,0,1,8.438,5.781Z",
    fill: "#185cff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportPrint);
export default __webpack_public_path__ + "static/media/report-print.c69f4971ba1887dadc096faaea0912d2.svg";
export { ForwardRef as ReactComponent };